import { jsonMember, jsonObject } from 'typedjson';
import { Id } from '@shared/types/id';

@jsonObject
export class EquipmentCategoryResponse {
  @jsonMember readonly id!: Id;
  @jsonMember readonly name!: string;
  @jsonMember readonly createdAt!: Date;
}
